<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      class="table-css"
      :columns="columns"
      :data="groupList"
      style="width: 100.1%;"
      :max-height="tableHeight"
    ></Table>
  </div>
</template>
<script>
import utils from "../../../../../../utils/utils.js";
var tableGroupResourceResource = {};
export default {
  name: "TableGroupResourceResource",
  data() {
    return {
      tableHeight: 0,
      companyId: "",
      columns: [
        {
          title: this.$t("RAM.AWS.IAM.Group.AccountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.IAM.Group.AccountId"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.IAM.Group.GroupName"),
          key: "groupName"
        },
        {
          title: this.$t("RAM.AWS.IAM.Group.NumberOfPeople"),
          key: "userNumber"
        },
        {
          title: this.$t("RAM.AWS.IAM.Group.PolicyType"),
          key: "policyTypeName"
        },
        {
          title: this.$t("RAM.AWS.IAM.Group.PolicyName"),
          key: "policyName"
        }
      ],
      groupList: []
    };
  },
  beforeCreate: function() {
    tableGroupResourceResource = this;
  },
  created() {
    eventBus.$on("companyId", function(companyId) {
      tableGroupResourceResource.companyId = companyId;
    });
    eventBus.$on("iamGroupName", function(iamGroupName) {
      tableGroupResourceResource.iamGroupName = iamGroupName;
    });
  },
  mounted: function() {
    window.addEventListener("resize", this.getTableHeight);
    this.getTableHeight();
  },
  methods: {
    getTableHeight() {
      this.tableHeight = window.innerHeight - 194;
    },
    showAll: function() {
      tableGroupResourceResource.getDate();
    },
    // 显示数据
    getDate: function() {
      tableGroupResourceResource.$api.resourceManagement
        .pagingQueryAwsIamGroup({
          companyId: tableGroupResourceResource.companyId,
          iamGroupName: tableGroupResourceResource.iamGroupName
        })
        .then(res => {
          this.groupList = res.data.records;
        });
    }
  }
};
</script>
<style scoped>
/* 滚动条 */
.table-css >>> .ivu-table-overflowY::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.table-css >>> .ivu-table-overflowY::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #ccc;
}
.table-css >>> .ivu-table-overflowY::-webkit-scrollbar-track {
  background: #eeeeef;
}
.table-css >>> .ivu-table-overflowY::-webkit-scrollbar-corner {
  background-color: #eeeeef;
}
.table-css >>> .ivu-table-overflowX {
  overflow-x: hidden !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/iam_config/group/TableGroupResource.vue